import React, { useCallback } from 'react'
import { components } from 'react-select'
import cx from 'classnames'
import styles from './Tags.module.css'
import CloseIcon from 'Icons/close.svg'
import PlusIcon from 'Icons/add.svg'

import ReactSelect from '../ReactSelect'

const AddTagIndicator = (props) => {
  return (
    <components.DropdownIndicator {...props}>
      <PlusIcon width='18' height='18' />
    </components.DropdownIndicator>
  )
}

const Tag = ({ children, ...rest }) => {
  return (
    <div className={cx('tag', styles.Tag)} {...rest}>
      <div className={styles.Label}>{children}</div>
      <div className={styles.RemoveIcon}>
        <CloseIcon width='16' height='16' />
      </div>
    </div>
  )
}

const TAG_REGEX = /^([\w-]+\s?)*\s*$/

const isValidOption = (inputValue) => {
  if (TAG_REGEX.test(inputValue)) {
    return inputValue.replace(/\s+$/, '').length >= 3
  }

  return false
}

const createTag = (v) => {
  const value = v.trim()

  return {
    value,
    label: value
  }
}

const Tags = (props) => {
  const { value = [], onRemove, onCreate, placeholder, ...rest } = props

  const handleRemoveTag = useCallback(
    (tag, index) => {
      onRemove(tag, index)
    },
    [onRemove]
  )

  const handleCreateTag = useCallback(
    (inputValue) => {
      const tag = createTag(inputValue)
      onCreate(tag)
    },
    [onCreate]
  )

  return (
    <div className={styles.Container}>
      {value.length !== 0 && (
        <div className={styles.Tags}>
          {value.map((tag, index) => {
            return (
              <Tag key={`TagList__${tag.value}`} onClick={() => handleRemoveTag(tag, index)}>
                {tag.label}
              </Tag>
            )
          })}
        </div>
      )}
      <ReactSelect
        {...rest}
        isMulti
        isClearable={false}
        controlShouldRenderValue={false}
        backspaceRemovesValue={false}
        placeholder={placeholder ?? 'Add tags'}
        value={value}
        onCreateOption={handleCreateTag}
        isValidNewOption={isValidOption}
        components={{
          DropdownIndicator: AddTagIndicator,
          ...(!rest.options && { Menu: null })
        }}
        styles={{
          input: (provided, state) => {
            const width = '100%'
            return { ...provided, width }
          }
        }}
      />
    </div>
  )
}

export default Tags
